import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
// CORRECCIÓN: Se agregó FaUtensils a la lista de imports
import { 
    FaArrowLeft, FaPrint, FaEye, FaLock, FaCheckCircle, 
    FaMoneyBillWave, FaCashRegister, FaChartLine, FaCalendarAlt, 
    FaTimes, FaReceipt, FaClock, FaUser, FaUtensils, FaDollarSign 
} from 'react-icons/fa';

const API_URL = 'https://api.alquilacarbolivia.com/api';

// Helper para formatear fechas en zona horaria de Bolivia
const formatBoliviaDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-BO', { timeZone: 'America/La_Paz' });
};

const formatBoliviaTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('es-BO', { timeZone: 'America/La_Paz', hour: '2-digit', minute: '2-digit' });
};



export default function MisVentas({ sucursalId, user, goBack }) {
    const [turnos, setTurnos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [ventasTurno, setVentasTurno] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [turnoSeleccionado, setTurnoSeleccionado] = useState(null);
    const [filtroEstado, setFiltroEstado] = useState('todos'); // todos, abiertos, cerrados

    useEffect(() => {
        fetchHistorial();
    }, [sucursalId]);

    const fetchHistorial = async () => {
        try {
            const res = await axios.get(`${API_URL}/caja/historial/${sucursalId}`);
            setTurnos(res.data);
            setLoading(false);
        } catch (error) { 
            console.error(error);
            setLoading(false);
        }
    };

    // --- FUNCIÓN UNIFICADA DE IMPRESIÓN ---
    const handleImpresion = async (tipo, id) => {
        if (!id) return;
        try {
            // tipo puede ser 'recibo', 'comanda' o 'reporte-cierre'
            const ruta = tipo === 'reporte-cierre' ? 'caja/reporte-cierre' : `ventas/${tipo}`;
            const res = await axios.get(`${API_URL}/${ruta}/${id}`);
            
            if (res.data && res.data.pdfUrl) {
                window.open(`https://api.alquilacarbolivia.com${res.data.pdfUrl}`, '_blank');
            } else {
                Swal.fire('Error', 'No se encontró el archivo PDF', 'error');
            }
        } catch (e) { 
            console.error(e);
            Swal.fire('Error', 'No se pudo generar el documento', 'error'); 
        }
    };

    // --- CIERRE DE CAJA ---
    const handleCerrarTurno = async (turnoData) => {
        const { value: montoReal } = await Swal.fire({
            title: 'Cierre de Caja',
            html: `
                <div class="text-center">
                    <p class="mb-2">Cajero: <strong>${turnoData.usuario}</strong></p>
                    <p class="text-danger mb-3">⚠️ Ingresa el total contado en caja (cierre ciego):</p>
                </div>
            `,
            input: 'number',
            inputPlaceholder: '0.00',
            showCancelButton: true,
            confirmButtonText: 'Cerrar Turno',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#dc3545',
            inputAttributes: { min: 0, step: 0.01 }
        });

        if (montoReal !== undefined && montoReal !== null) {
            try {
                // 1. Cerrar en BD
                await axios.post(`${API_URL}/caja/cerrar`, {
                    id: turnoData.id,
                    monto_final: montoReal
                });
                
                // 2. Imprimir el mismo PDF que en el POS
                handleImpresion('reporte-cierre', turnoData.id);
                
                fetchHistorial(); 
                Swal.fire({ icon: 'success', title: 'Caja Cerrada', timer: 1500, showConfirmButton: false });

            } catch (error) {
                Swal.fire('Error', 'No se pudo cerrar la caja', 'error');
            }
        }
    };

    // --- AJUSTAR FALTANTE ---
    const handleAjustarFaltante = async (turnoData, diferencia) => {
        const montoFaltante = Math.abs(diferencia);
        const { value: confirmado } = await Swal.fire({
            title: 'Ajustar Faltante',
            html: `
                <div class="text-center">
                    <p class="text-danger fw-bold mb-3">Faltante: Bs. ${montoFaltante.toFixed(2)}</p>
                    <p>¿Deseas agregar Bs. ${montoFaltante.toFixed(2)} para cuadrar la caja?</p>
                    <p class="text-muted small">Esto actualizará el monto final del turno</p>
                </div>
            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, ajustar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745'
        });

        if (confirmado) {
            try {
                await axios.post(`${API_URL}/caja/ajustar-faltante/${turnoData.id}`, {
                    monto_ajuste: montoFaltante
                });
                
                fetchHistorial();
                Swal.fire({ icon: 'success', title: 'Faltante Ajustado', text: 'El turno ha sido cuadrado correctamente', timer: 2000, showConfirmButton: false });
            } catch (error) {
                Swal.fire('Error', 'No se pudo ajustar el faltante', 'error');
            }
        }
    };

    // --- VER VENTAS DEL TURNO ---
    const verVentas = async (turno) => {
        setTurnoSeleccionado(turno);
        try {
            const res = await axios.get(`${API_URL}/caja/ventas/${turno.id}`);
            setVentasTurno(res.data);
            setShowModal(true);
        } catch (error) { 
            Swal.fire('Error', 'No se pudieron cargar las ventas', 'error');
        }
    };

    // --- CÁLCULOS DE ESTADÍSTICAS ---
    const calcularEstadisticas = () => {
        const totalVentas = turnos.reduce((sum, t) => sum + parseFloat(t.total_ventas || 0), 0);
        const turnosAbiertos = turnos.filter(t => t.estado === 'abierto').length;
        const turnosCerrados = turnos.filter(t => t.estado === 'cerrado').length;
        
        return { totalVentas, turnosAbiertos, turnosCerrados, totalTurnos: turnos.length };
    };

    const filtrarTurnos = () => {
        switch(filtroEstado) {
            case 'abiertos': return turnos.filter(t => t.estado === 'abierto');
            case 'cerrados': return turnos.filter(t => t.estado === 'cerrado');
            default: return turnos;
        }
    };

    const stats = calcularEstadisticas();
    const turnosFiltrados = filtrarTurnos();

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <div className="spinner-border text-primary" role="status"><span className="visually-hidden">Cargando...</span></div>
            </div>
        );
    }

    return (
        <div className="container-fluid p-0" style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
            {/* Header Mejorado */}
            <div style={{
                background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
                padding: '1.5rem 2rem',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}>
                <div className="d-flex align-items-center gap-3">
                    <button 
                        className="btn btn-light shadow-sm rounded-circle" 
                        onClick={goBack}
                        style={{ width: '40px', height: '40px' }}
                    >
                        <FaArrowLeft/>
                    </button>
                    <div className="text-white">
                        <h3 className="m-0 fw-bold d-flex align-items-center gap-2">
                            <FaCashRegister style={{ fontSize: '1.5rem' }}/> 
                            Historial de Turnos
                        </h3>
                        <p className="m-0 opacity-75" style={{ fontSize: '0.9rem' }}>
                            Control de caja y ventas por turno
                        </p>
                    </div>
                </div>
            </div>

            <div className="p-4">
                {/* Tarjetas de estadísticas */}
                <div className="row g-3 mb-4">
                    <div className="col-md-3">
                        <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' }}>
                            <div className="card-body p-3 text-white">
                                <p className="m-0 opacity-75 small">Ventas Totales</p>
                                <h4 className="m-0 fw-bold">Bs. {stats.totalVentas.toFixed(2)}</h4>
                                <div className="position-absolute top-0 end-0 p-3 opacity-25"><FaMoneyBillWave size={30}/></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' }}>
                            <div className="card-body p-3 text-white">
                                <p className="m-0 opacity-75 small">Total Turnos</p>
                                <h4 className="m-0 fw-bold">{stats.totalTurnos}</h4>
                                <div className="position-absolute top-0 end-0 p-3 opacity-25"><FaChartLine size={30}/></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' }}>
                            <div className="card-body p-3 text-white">
                                <p className="m-0 opacity-75 small">Turnos Abiertos</p>
                                <h4 className="m-0 fw-bold">{stats.turnosAbiertos}</h4>
                                <div className="position-absolute top-0 end-0 p-3 opacity-25"><FaCheckCircle size={30}/></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)' }}>
                            <div className="card-body p-3 text-white">
                                <p className="m-0 opacity-75 small">Turnos Cerrados</p>
                                <h4 className="m-0 fw-bold">{stats.turnosCerrados}</h4>
                                <div className="position-absolute top-0 end-0 p-3 opacity-25"><FaLock size={30}/></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tabla de turnos */}
                <div className="card border-0 shadow-sm" style={{ borderRadius: '16px' }}>
                    <div className="card-header bg-white border-0 p-4 d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <h5 className="m-0 fw-bold text-dark"><FaCashRegister className="me-2 text-info"/> Turnos Registrados</h5>
                        
                        <div className="btn-group shadow-sm">
                            <button className={`btn btn-sm ${filtroEstado==='todos'?'btn-info text-white':'btn-outline-info'}`} onClick={()=>setFiltroEstado('todos')}>Todos</button>
                            <button className={`btn btn-sm ${filtroEstado==='abiertos'?'btn-info text-white':'btn-outline-info'}`} onClick={()=>setFiltroEstado('abiertos')}>Abiertos</button>
                            <button className={`btn btn-sm ${filtroEstado==='cerrados'?'btn-info text-white':'btn-outline-info'}`} onClick={()=>setFiltroEstado('cerrados')}>Cerrados</button>
                        </div>
                    </div>

                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th className="px-4 py-3 text-muted">ID</th>
                                        <th className="text-muted">FECHA APERTURA</th>
                                        <th className="text-muted">ESTADO</th>
                                        <th className="text-muted">CAJERO</th>
                                        <th className="text-end text-muted">VENTAS</th>
                                        <th className="text-center text-muted">ACCIONES</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {turnosFiltrados.map(t => (
                                        <tr key={t.id} style={{background: t.estado === 'abierto' ? '#fffbeb' : 'white'}}>
                                            <td className="px-4 fw-bold text-primary">#{t.id}</td>
                                            <td>
                                                <div className="fw-semibold">{formatBoliviaDate(t.fecha_apertura)}</div>
                                                <small className="text-muted">{formatBoliviaTime(t.fecha_apertura)}</small>
                                            </td>
                                            <td>
                                                <span className={`badge ${t.estado === 'abierto' ? 'bg-success' : 'bg-secondary'} rounded-pill px-3`}>
                                                    {t.estado === 'abierto' ? 'ABIERTO' : 'CERRADO'}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center gap-2">
                                                    <div className="rounded-circle bg-info text-white d-flex align-items-center justify-content-center" style={{width:30, height:30, fontSize:'0.8rem'}}>
                                                        {(t.usuario || 'S').charAt(0).toUpperCase()}
                                                    </div>
                                                    <span>{t.usuario || 'Sistema'}</span>
                                                </div>
                                            </td>
                                            <td className="text-end fw-bold text-dark">Bs. {parseFloat(t.total_ventas || 0).toFixed(2)}</td>
                                            <td className="text-center">
                                                <div className="d-flex justify-content-center gap-2">
                                                    {t.estado === 'abierto' ? (
                                                        <button className="btn btn-sm btn-danger fw-bold" onClick={() => handleCerrarTurno(t)}>
                                                            <FaLock className="me-1"/> CERRAR
                                                        </button>
                                                    ) : (
                                                        <>
                                                            {(() => {
                                                                const fondoCaja = parseFloat(t.monto_inicial || 0);
                                                                const ventasEfectivo = parseFloat(t.ventas_efectivo || 0);
                                                                const esperado = fondoCaja + ventasEfectivo;
                                                                const contado = parseFloat(t.monto_final || 0);
                                                                const diferencia = contado - esperado;
                                                                const esFaltante = diferencia < -0.5;
                                                                
                                                                
                                                                return (
                                                                    <>
                                                                        {esFaltante && (
                                                                            <button className="btn btn-sm btn-warning me-2" onClick={() => handleAjustarFaltante(t, diferencia)}>
                                                                                <FaDollarSign className="me-1"/> AJUSTAR
                                                                            </button>
                                                                        )}
                                                                        <button className="btn btn-sm btn-secondary" onClick={() => handleImpresion('reporte-cierre', t.id)}>
                                                                            <FaPrint className="me-1"/> REPORTE
                                                                        </button>
                                                                    </>
                                                                );
                                                            })()}
                                                        </>
                                                    )}
                                                    <button className="btn btn-sm btn-outline-primary" onClick={() => verVentas(t)}>
                                                        <FaEye className="me-1"/> VENTAS
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {turnosFiltrados.length === 0 && (
                                        <tr><td colSpan="6" className="text-center py-5 text-muted">No se encontraron turnos</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Detalle de Ventas */}
            {showModal && turnoSeleccionado && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}>
                    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px', overflow: 'hidden' }}>
                            <div className="modal-header text-white" style={{ background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)' }}>
                                <div>
                                    <h5 className="m-0 fw-bold"><FaReceipt className="me-2"/> Ventas del Turno #{turnoSeleccionado.id}</h5>
                                    <small className="opacity-75">Cajero: {turnoSeleccionado.usuario}</small>
                                </div>
                                <button className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
                            </div>
                            <div className="modal-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-hover align-middle mb-0">
                                        <thead className="bg-light">
                                            <tr>
                                                <th className="px-4 py-3">HORA</th>
                                                <th>CLIENTE</th>
                                                <th>MÉTODO</th>
                                                <th>PRODUCTOS</th>
                                                <th className="text-end">TOTAL</th>
                                                <th className="text-center">OPCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ventasTurno.map(v => (
                                                <tr key={v.id}>
                                                    <td className="px-4 text-muted"><FaClock className="me-2"/>{formatBoliviaTime(v.fecha)}</td>
                                                    <td>{v.cliente_nombre || 'Público General'}</td>
                                                    <td>
                                                        <span className={`badge ${v.metodo_pago.includes('efectivo') ? 'bg-success' : 'bg-primary'} rounded-pill text-uppercase`}>
                                                            {v.metodo_pago}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <div className="small">
                                                            {v.productos && v.productos.length > 0 ? (
                                                                v.productos.map((p, idx) => (
                                                                    <div key={idx} className="text-muted">
                                                                        {p.cantidad}x {p.producto_nombre}
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <span className="text-muted">Sin productos</span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="text-end fw-bold">Bs. {parseFloat(v.total).toFixed(2)}</td>
                                                    <td className="text-center">
                                                        <button className="btn btn-sm btn-outline-secondary" onClick={() => handleImpresion('recibo', v.id)}>
                                                            <FaPrint/> Recibo
                                                        </button>
                                                        <button className="btn btn-sm btn-outline-warning ms-2" onClick={() => handleImpresion('comanda', v.id)}>
                                                            <FaUtensils/> Comanda
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {ventasTurno.length === 0 && (
                                                <tr><td colSpan="5" className="text-center py-4 text-muted">No hubo ventas en este turno</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer bg-light">
                                <button className="btn btn-secondary px-4 rounded-pill" onClick={() => setShowModal(false)}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}